var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.713,
    height: 16.713,
    viewBox: "0 0 16.713 16.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(-973.5 -606.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M4.746,10.856H3L10.856,3l7.856,7.856H16.967",
    transform: "translate(971 604)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M5,12v6.111a1.746,1.746,0,0,0,1.746,1.746h8.729a1.746,1.746,0,0,0,1.746-1.746V12",
    transform: "translate(970.746 602.856)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M9,19.984V14.746A1.746,1.746,0,0,1,10.746,13h1.746a1.746,1.746,0,0,1,1.746,1.746v5.238",
    transform: "translate(970.238 602.729)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePurple);
export default __webpack_public_path__ + "static/media/home-purple.3ad789722460c34ee98454000c923817.svg";
export { ForwardRef as ReactComponent };